export default [
  {
    title: "menu.home",
    route: "profile",
    icon: "HomeIcon",
    roles: [
      "ROLE_SYSTEM",
      "ROLE_ADMIN",
      "ROLE_REVIEWER",
      "ROLE_USER",
      "ROLE_APPROVER",
      "ROLE_RIDER",
    ],
  },
  {
    title: "menu.msgrequest",
    icon: "FileIcon",
    route: "request-search",
    roles: [
      "ROLE_SYSTEM",
      "ROLE_ADMIN",
      "ROLE_REVIEWER",
      "ROLE_USER",
      "ROLE_APPROVER",
    ],
  },
  {
    title: "menu.reqmanage",
    icon: "ClipboardIcon",
    route: "rider-menu",
    roles: ["ROLE_SYSTEM" , "ROLE_ADMIN" , "ROLE_RIDER"],
  },
  {
    title: "report.report",
    icon: "MenuIcon",
    roles: ["ROLE_SYSTEM", "ROLE_ADMIN", "ROLE_REVIEWER", "ROLE_APPROVER"],
    children: [
      {
        title: "menu.riderper",
        icon: "SendIcon",
        route: "rider-report",
        roles: ["ROLE_SYSTEM", "ROLE_ADMIN", "ROLE_REVIEWER", "ROLE_APPROVER"],
      },
      {
        title: "menu.usgstat",
        icon: "UsersIcon",
        route: "rider-deptreport",
        roles: ["ROLE_SYSTEM", "ROLE_ADMIN", "ROLE_REVIEWER", "ROLE_APPROVER"],
      },
    ],
  },
  {
    title: "Admin",
    icon: "UsersIcon",
    route: "admin-search",
    roles: ["ROLE_SYSTEM", "ROLE_ADMIN", "ROLE_APPROVER"],
  },
  {
    title: "menu.master",
    icon: "ServerIcon",
    roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
    children: [
      {
        title: "menu.customer",
        icon: "UserIcon",
        route: "customer-search",
        roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
      },
    ],
  },
  {
    title: "menu.setting",
    icon: "SettingsIcon",
    roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
    children: [
      {
        title: "menu.user",
        icon: "UserIcon",
        route: "user-search",
        roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
      },
      {
        title: "leadcust.department2",
        icon: "GridIcon",
        route: "department-search",
        roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
      },
    ],
  },
  {
    title: "menu.pass",
    icon: "SettingsIcon",
    route: "user-pass",
    roles: [
      "ROLE_SYSTEM",
      "ROLE_ADMIN",
      "ROLE_REVIEWER",
      "ROLE_USER",
      "ROLE_APPROVER",
      "ROLE_RIDER",
    ],
  },
  {
    title: "menu.template",
    icon: "LayoutIcon",
    route: "template-search",
    roles: ["ROLE_SYSTEM", "ROLE_ADMIN"],
  },
];
